enum DragonbonesAnimationEvent {
    PLAY = 'play',
    COMPLETE = 'complete',
    FADE_IN = 'fade_in',
}
export default DragonbonesAnimationEvent;
